/** Site green (nav, footer, buttons). Re-exported from NavBar for existing imports. */
export const NAV_BAR_BG = "#243d33";
